module.exports = "<div class=\"header\">\n  <div>\n    <h2>{{properties.name}}</h2>\n  </div>\n</div>\n<div class=\"content\">\n  <div *ngIf=\"properties.status\">\n    <h4>{{'status' | translate}}</h4>\n    <span>{{properties.status | translate}}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/real-time/real-time/real-time-region-popup/real-time-region-popup.component.html
// module id = ./src/app/real-time/real-time/real-time-region-popup/real-time-region-popup.component.html
// module chunks = main